import type { App } from 'vue'
import { type Cacheable, type ICache, createAuth0 } from '@auth0/auth0-vue'

const cache: ICache = {
  set<T = Cacheable>(key: string, entry: T) {
    localStorage.setItem(key, JSON.stringify(entry))

    if (typeof entry === 'object' && entry !== null && 'id_token' in entry) {
      localStorage.setItem('id_token', entry.id_token as string)
    }
  },

  get<T = Cacheable>(key: string): T | undefined {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : undefined
  },

  remove(key: string) {
    localStorage.removeItem(key)
  },

  allKeys() {
    const keys: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key) {
        keys.push(key)
      }
    }
    return keys
  },
}

export const auth0 = createAuth0({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  useRefreshTokensFallback: true,
  authorizationParams: {
    redirect_uri: window.location.origin,
    prompt: 'login',
    scope: 'openid profile email offline_access',
  },
  cache,
  useRefreshTokens: true,
})

export default function auth0Plugin(app: App) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  app.use(auth0)
}
